import styled from "styled-components";
import { borders } from "../theme";

export const HeaderBar = styled.div`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  height: 3.75rem;
  justify-content: space-between;
  padding: 0.5rem 1.5rem;
  width: 100%;
  border-bottom: ${borders.standard};
`;
